function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "mic"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m15 20h-6c-.552 0-1 .447-1 1s.448 1 1 1h6c.553 0 1-.447 1-1s-.447-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18 11c-.553 0-1 .447-1 1 0 2.757-2.243 5-5 5s-5-2.243-5-5c0-.553-.448-1-1-1s-1 .447-1 1c0 3.859 3.14 7 7 7 3.859 0 7-3.141 7-7 0-.553-.447-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 16c2.206 0 4-1.794 4-4v-6c0-2.206-1.794-4-4-4s-4 1.794-4 4v6c0 2.206 1.794 4 4 4zm-2-10c0-1.103.897-2 2-2s2 .897 2 2v6c0 1.103-.897 2-2 2s-2-.897-2-2z"
})));

var Svg004Microphone = function Svg004Microphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg004Microphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/004-microphone.0d096d63.svg";
export { ForwardRef as ReactComponent };